import React from 'react'
import './videoplayer.scss'
const VideoPlayer = ({ videoSrc, Title }) => {
    return (
        <div className="video-container">
            <h2>{Title}</h2>
            <video width="100%" height="100%" controls>
                <source src={videoSrc} type="video/mp4" />
            </video>
        </div>
    )
}

export default VideoPlayer  